module.exports = "\n<router-outlet></router-outlet>\n\n"


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main